import { formatCount } from '../lib/format';

/**
 * Paginacao por deslocamento (RNF15).
 *
 * "Anterior / proxima" com o intervalo escrito ("21–40 de 143"), sem lista de
 * numeros de pagina: o painel e uma fila operacional, e o leitor anda para
 * frente ou para tras, nao salta para a pagina 7.
 */
export function Pagination({
  total,
  limit,
  offset,
  onChange,
}: {
  readonly total: number;
  readonly limit: number;
  readonly offset: number;
  readonly onChange: (offset: number) => void;
}): JSX.Element | null {
  if (total <= limit && offset === 0) {
    return null;
  }
  const first = Math.min(offset + 1, total);
  const last = Math.min(offset + limit, total);
  const temAnterior = offset > 0;
  const temProxima = offset + limit < total;

  return (
    <nav aria-label="Paginação" className="flex items-center justify-between gap-3 text-sm text-ink-muted">
      <p className="tabular-nums">
        {formatCount(first)}–{formatCount(last)} de {formatCount(total)}
      </p>
      <div className="inline-flex gap-1">
        <button
          type="button"
          disabled={!temAnterior}
          onClick={() => onChange(Math.max(0, offset - limit))}
          className="h-8 rounded-md border border-line bg-surface px-3 text-ink transition-colors hover:bg-elevated disabled:cursor-not-allowed disabled:opacity-40"
        >
          Anterior
        </button>
        <button
          type="button"
          disabled={!temProxima}
          onClick={() => onChange(offset + limit)}
          className="h-8 rounded-md border border-line bg-surface px-3 text-ink transition-colors hover:bg-elevated disabled:cursor-not-allowed disabled:opacity-40"
        >
          Próxima
        </button>
      </div>
    </nav>
  );
}
